export enum ShipmentType {
  LTL = 'LTL',
  FTL = 'FTL',
}
